import { render, staticRenderFns } from "./EditPortalContentModal.vue?vue&type=template&id=06517c0b&"
import script from "./EditPortalContentModal.vue?vue&type=script&lang=js&"
export * from "./EditPortalContentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports